import { slugify } from '../utils/slugify';

export const getPublicUrlScheduleCompanyService = (userId, userName, serviceId) => `${process.env.REACT_APP_WEB}/public-services/${userId}/${serviceId}/${slugify(userName)}`;

export const getPublicUrlScheduleCompany = (userId, userName) => `${process.env.REACT_APP_WEB}/public-services/${userId}/${slugify(userName)}`;
